'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _UIIllustration = require('UIComponents/image/UIIllustration');

var _UIIllustration2 = _interopRequireDefault(_UIIllustration);

var _getUsageTracker = require('pricing-pages-unified-ui/utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

var _reactRhumb = require('react-rhumb');

var _Tracking = require('../constants/Tracking');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ErrorPage() {
  (0, _react.useEffect)(function () {
    (0, _getUsageTracker2.default)().track('pageView', {
      screen: _Tracking.SCREENS.ERROR
    });
  }, []);

  return _react2.default.createElement(
    'div',
    { className: 'flex-column align-center p-all-10' },
    _react2.default.createElement(_reactRhumb.NavMarker, { name: 'ERROR_PAGE' }),
    _react2.default.createElement(_UIIllustration2.default, { className: 'm-y-10', name: 'errors/icecream', height: 200 }),
    _react2.default.createElement(
      'h4',
      { className: 'm-top-6' },
      _react2.default.createElement(_FormattedMessage2.default, { message: 'errorPage.title' })
    ),
    _react2.default.createElement(
      'p',
      { className: 'm-bottom-10' },
      _react2.default.createElement(_FormattedMessage2.default, { message: 'errorPage.paragraph' })
    )
  );
}

exports.default = ErrorPage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/ErrorPage.js
// module id = 374
// module chunks = 3 4